export const holidays: any = {
  us: {
    "2021": ["2021-1-1", "2021-7-4", "2021-9-6", "2021-11-25", "2021-12-25"],
    "2022": ["2022-1-1", "2022-7-4", "2022-9-5", "2022-11-24", "2022-12-25"],
    "2023": [
      "2023-1-1",
      "2023-7-4",
      "2023-9-4",
      "2023-11-23",
      "2023-12-25",
      "2023-12-26",
    ],
    "2024": ["2024-1-1", "2024-7-4", "2024-9-2", "2024-11-28", "2024-12-25"],
    "2025": ["2025-1-1", "2025-7-4", "2025-9-1", "2025-11-27", "2025-12-25"],
    "2026": ["2026-1-1", "2026-7-4", "2026-9-7", "2026-11-26", "2026-12-25"],
    "2027": ["2027-1-1", "2027-7-4", "2027-9-6", "2027-11-25", "2027-12-25"],
    "2028": ["2028-1-1", "2028-7-4", "2028-9-4", "2028-11-23", "2028-12-25"],
    "2029": ["2028-1-1", "2028-7-4", "2028-9-3", "2028-11-22", "2028-12-25"],
    "2030": ["2028-1-1", "2028-7-4", "2028-9-2", "2028-11-28", "2028-12-25"],
  },
  canada: {
    "2021": [
      "2021-1-1",
      "2021-2-15",
      "2021-4-2",
      "2021-5-24",
      "2021-7-1",
      "2021-9-6",
      "2021-10-11",
      "2021-12-25",
    ],
    "2022": [
      "2022-1-1",
      "2022-2-21",
      "2022-4-15",
      "2022-5-23",
      "2022-7-1",
      "2022-9-5",
      "2022-10-10",
      "2022-12-25",
    ],
    "2023": [
      "2023-1-1",
      "2023-2-20",
      "2023-4-7",
      "2023-5-22",
      "2023-7-1",
      "2023-9-4",
      "2023-10-9",
      "2023-12-25",
    ],
    "2024": [
      "2024-1-1",
      "2024-2-19",
      "2024-3-29",
      "2024-5-20",
      "2024-7-1",
      "2024-9-2",
      "2024-10-14",
      "2024-12-25",
    ],
    "2025": [
      "2025-1-1",
      "2025-2-17",
      "2025-4-18",
      "2025-5-19",
      "2025-7-1",
      "2025-9-1",
      "2025-10-13",
      "2025-12-25",
    ],
    "2026": [
      "2026-1-1",
      "2026-2-16",
      "2026-4-3",
      "2026-5-18",
      "2026-7-1",
      "2026-9-7",
      "2026-10-12",
      "2026-12-25",
    ],
    "2027": [
      "2027-1-1",
      "2027-2-15",
      "2027-3-26",
      "2027-5-24",
      "2027-7-1",
      "2027-9-6",
      "2027-10-11",
      "2027-12-25",
    ],
    "2028": [
      "2028-1-1",
      "2028-2-21",
      "2028-4-14",
      "2028-5-22",
      "2028-7-1",
      "2028-9-4",
      "2028-10-9",
      "2028-12-25",
    ],
    "2029": [
      "2029-1-1",
      "2029-2-19",
      "2029-3-30",
      "2029-5-21",
      "2029-7-1",
      "2029-9-3",
      "2029-10-8",
      "2029-12-25",
    ],
    "2030": [
      "2030-1-1",
      "2030-2-18",
      "2030-4-19",
      "2030-5-20",
      "2030-7-1",
      "2030-9-2",
      "2030-10-14",
      "2030-12-25",
    ],
  },
  uk: {
    "2021": [
      "2021-1-1",
      "2021-4-2",
      "2021-4-5",
      "2021-5-3",
      "2021-5-31",
      "2021-8-30",
      "2021-12-25",
      "2021-12-26",
    ],
    "2022": [
      "2022-1-1",
      "2022-4-15",
      "2022-4-18",
      "2022-5-2",
      "2022-5-30",
      "2022-6-2",
      "2022-8-29",
      "2022-12-25",
      "2022-12-26",
      "2022-12-27",
    ],
    "2023": [
      "2023-1-1",
      "2023-4-7",
      "2023-4-10",
      "2023-5-1",
      "2023-5-29",
      "2023-8-28",
      "2023-12-25",
      "2023-12-26",
    ],
    "2024": [
      "2024-1-1",
      "2024-3-29",
      "2024-4-1",
      "2024-5-6",
      "2024-5-27",
      "2024-8-26",
      "2024-12-25",
      "2024-12-26",
    ],
    "2025": [
      "2025-1-1",
      "2025-4-18",
      "2025-4-21",
      "2025-5-5",
      "2025-5-26",
      "2025-8-25",
      "2025-12-25",
      "2025-12-26",
    ],
    "2026": [
      "2026-1-1",
      "2026-4-3",
      "2026-4-6",
      "2026-5-4",
      "2026-5-25",
      "2026-8-31",
      "2026-12-25",
      "2026-12-26",
    ],
    "2027": [
      "2027-1-1",
      "2027-3-26",
      "2027-3-29",
      "2027-5-3",
      "2027-5-31",
      "2027-8-30",
      "2027-12-25",
      "2027-12-26",
    ],
    "2028": [
      "2028-1-1",
      "2028-4-14",
      "2028-4-17",
      "2028-5-1",
      "2028-5-29",
      "2028-8-28",
      "2028-12-25",
      "2028-12-26",
    ],
    "2029": [
      "2029-1-1",
      "2029-3-30",
      "2029-4-2",
      "2029-5-7",
      "2029-5-28",
      "2029-8-27",
      "2029-12-25",
      "2029-12-26",
    ],
    "2030": [
      "2030-1-1",
      "2030-4-19",
      "2030-4-22",
      "2030-5-6",
      "2030-5-27",
      "2030-8-26",
      "2030-12-25",
      "2030-12-26",
    ],
  },
  canada_1: {
    "2021": ["2021-8-2", "2021-12-26"],
    "2022": ["2022-8-1", "2022-12-26"],
    "2023": ["2023-8-7", "2023-12-26"],
    "2024": ["2024-8-5", "2024-12-26"],
    "2025": ["2025-8-4", "2025-12-26"],
    "2026": ["2026-8-3", "2026-12-26"],
    "2027": ["2027-8-2", "2027-12-26"],
    "2028": ["2028-8-7", "2028-12-26"],
    "2029": ["2029-8-6", "2029-12-26"],
    "2030": ["2030-8-5", "2030-12-26"],
  },
  canada_2: {
    "2021": ["2021-11-11"],
    "2022": ["2022-11-11"],
    "2023": ["2023-11-11"],
    "2024": ["2024-11-11"],
    "2025": ["2025-11-11"],
    "2026": ["2026-11-11"],
    "2027": ["2027-11-11"],
    "2028": ["2028-11-11"],
    "2029": ["2029-11-11"],
    "2030": ["2030-11-11"],
  },
  canada_3: {
    "2021": ["2021-8-2", "2021-11-11"],
    "2022": ["2022-8-1", "2022-11-11"],
    "2023": ["2023-8-7", "2023-11-11"],
    "2024": ["2024-8-5", "2024-11-11"],
    "2025": ["2025-8-4", "2025-11-11"],
    "2026": ["2026-8-3", "2026-11-11"],
    "2027": ["2027-8-2", "2027-11-11"],
    "2028": ["2028-8-7", "2028-11-11"],
    "2029": ["2029-8-6", "2029-11-11"],
    "2030": ["2030-8-5", "2030-11-11"],
  },
};

export const minimumGroupSize = {
  default: 13,
  winnipeg: 7,
  "wembley, london": 13,
  croydon: 13,
  nashville: 15,
};

export const largeGroupMinimums = {
  default: 30,
  frisco: 16,
  croydon: 24,
  washington: 13,
};

export const disclaimerMinimums = {
  atlanta: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  aurora: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  burlington: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  brooklyn: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  chicago: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "chicago (west loop)": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "chicago (lake view)": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  dallas: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  denver: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "denver downtown": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  huntsville: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  indianapolis: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  kitchener: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "wembley, london": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  croydon: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  matawan: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  mississauga: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  minneapolis: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "minneapolis (city center)": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  nashville: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  oklahoma: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  ottawa: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "san francisco": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "san diego": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  surrey: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  toronto: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  vaughan: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  washington: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  winnipeg: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "colorado springs": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  windsor: [
    "A minimum payment of <span>6 admissions</span> is required for 1 lane.",
  ],
  waterloo: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  fresno: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  syracuse: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  rochester: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  fairfax: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "fort worth": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  charlotte: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "spanish fort": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  waldorf: [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
  "long beach": [
    "A minimum payment of <span>4 admissions</span> is required for 1 lane.",
  ],
};

export const disclaimerLargeGroupMinimums = {
  A1: "Bookings of this size reserve <span>2 lanes</span>. Should your guest list <span>not reach 13</span> you are <span>responsible</span> for <span>13 regular admission payments</span>.",
  A25: "Bookings of this size reserve <span>3 lanes</span>. Should your guest list <span>not reach 25</span> you are <span>responsible</span> for <span>25 regular admission payments</span>.",
  A31: "Bookings of this size reserve <span>3 lanes</span>. Should your guest list <span>not reach 31</span> you are <span>responsible</span> for <span>31 corporate admission payments</span>.",
  A37: "Bookings of this size reserve <span>4 lanes</span>. Should your guest list <span>not reach 37</span> you are <span>responsible</span> for <span>37 corporate admission payments</span>.",
  A49: "Bookings of this size reserve <span>5 lanes</span>. Should your guest list <span>not reach 49</span> you are <span>responsible</span> for <span>49 corporate admission payments</span>.",
  A61: "Bookings of this size reserve <span>6 lanes</span>. Should your guest list <span>not reach 61</span> you are <span>responsible</span> for <span>61 corporate admission payments</span>.",
  U1: "Bookings of this size reserve <span>2 lanes</span>. Should your guest list <span>not reach 13</span> you are <span>responsible</span> for <span>13 regular admission payments</span>.",
  U13: "Bookings of this size reserve <span>3 lanes</span>. Should your guest list <span>not reach 17</span> you are <span>responsible</span> for <span>17 regular admission payments</span>.",
  U25: "Bookings of this size reserve <span>3 lanes</span>. Should your guest list <span>not reach 25</span> you are <span>responsible</span> for <span>25 corporate admission payments</span>.",
  U37: "Bookings of this size reserve <span>4 lanes</span>. Should your guest list <span>not reach 37</span> you are <span>responsible</span> for <span>37 corporate rate admission payments</span>.",
  U49: "Bookings of this size reserve <span>5 lanes</span>. Should your guest list <span>not reach 49</span> you are <span>responsible</span> for <span>49 corporate rate admission payments</span>.",
  U61: "Bookings of this size reserve <span>6 lanes</span>. Should your guest list <span>not reach 61</span> you are <span>responsible</span> for <span>61 corporate rate admission payments</span>.",
  W1: "Bookings of this size reserve <span>2 lanes</span>. Should your guest list <span>not reach 13</span> you are <span>responsible</span> for <span>13 corporate rate admission payments</span>.",
};

export const locationLanes = [
  {
    location: "alexandria",
    lanes: 7,
  },
  {
    location: "atlanta",
    lanes: 10,
  },
  {
    location: "charlotte",
    lanes: 9,
  },
  {
    location: "chicago",
    lanes: 2,
  },
  {
    location: "chicago (west loop)",
    lanes: 2,
  },
  {
    location: "colorado springs",
    lanes: 6,
  },
  {
    location: "dallas",
    lanes: 6,
  },
  {
    location: "denver",
    lanes: 5,
  },
  {
    location: "denver downtown",
    lanes: 7,
  },
  {
    location: "fresno",
    lanes: 3,
  },
  {
    location: "indianapolis",
    lanes: 10,
  },
  {
    location: "long beach",
    lanes: 7,
  },
  {
    location: "minneapolis",
    lanes: 10,
  },
  {
    location: "minneapolis (city center)",
    lanes: 9,
  },
  {
    location: "nashville",
    lanes: 14,
  },
  {
    location: "oklahoma",
    lanes: 3,
  },
  {
    location: "rochester",
    lanes: 6,
  },
  {
    location: "san francisco",
    lanes: 4,
  },
  {
    location: "spanish fort",
    lanes: 4,
  },
  {
    location: "syracuse",
    lanes: 5,
  },
  {
    location: "waldorf",
    lanes: 12,
  },
  {
    location: "burlington",
    lanes: 3,
  },
  {
    location: "mississauga",
    lanes: 5,
  },
  {
    location: "ottawa",
    lanes: 3,
  },
  {
    location: "surrey",
    lanes: 3,
  },
  {
    location: "waterloo",
    lanes: 5,
  },
  {
    location: "windsor",
    lanes: 4,
  },
  {
    location: "winnipeg",
    lanes: 1,
  }
];

export const specificHolidays = {
  us: ["jan 1", "jul 4", "nov 25", "dec 25"],
  canada: [],
  uk: [],
};

export const leaguesBlockedLocations = [
  // Canada
  // 'Burlington',
  // 'Ottawa',
  // 'Surrey',
  // 'Waterloo',
  // 'Windsor',
  // 'Winnipeg',
  // 'Mississauga',
  "Vaughan",
  // USA
  // 'Atlanta',
  // 'Alexandria',
  "Aurora",
  // 'Charlotte',
  "Chicago (Lake View)",
  // 'Chicago (West Loop)',
  // 'Colorado Springs',
  // 'Dallas',
  "Denver",
  // 'Denver Downtown',
  "Fairfax",
  "Fort Worth",
  // 'Fresno',
  "Huntsville",
  // 'Indianapolis',
  "North Indianapolis",
  "Greensboro",
  // 'Long Beach',
  "Matawan",
  // 'Minneapolis',
  "Minneapolis (City Center)",
  // 'Nashville',
  "Sacramento",
  "Spanish Fort",
  "Westminster",
  // 'Washington DC',
  "Baton Rouge",
  // 'Oklahoma',
  "Richmond",
  "Waldorf",
  // 'Rochester',
  "San Diego",
  // 'San Francisco',
  // 'Syracuse',
  // 'Fresno',
  // UK
  // 'Croydon',
  // 'Wembley, London'
];

export const OtherLocations = {
  Denver: "Denver Downtown",
  "Denver Downtown": "Denver",
  "Chicago (West Loop)": "Chicago (Lake View)",
  Chicago: "Chicago (Lake View)",
  "Chicago (Lake View)": "Chicago (West Loop)",
  Minneapolis: "Minneapolis (City Center)",
  "Minneapolis (City Center)": "Minneapolis",
  Fairfax: "Washington",
};

export const LocationUrl = {
  Denver: "/locations/axe-throwing-denver",
  "Denver Downtown": "/locations/axe-throwing-denver-downtown",
  "Chicago (West Loop)": "/locations/axe-throwing-chicago-west-loop",
  Chicago: "/locations/axe-throwing-chicago-west-loop",
  "Chicago (Lake View)": "/locations/axe-throwing-chicago-lake-view",
  Minneapolis: "/locations/axe-throwing-minneapolis",
  "Minneapolis (City Center)":
    "/locations/axe-throwing-minneapolis-city-center",
  Washington: "/locations/axe-throwing-washington-dc",
};

export const knifeAddonLocations = [
  "Alexandria",
  "Atlanta",
  "Burlington",
  "Charlotte",
  "Chicago (Lake View)",
  "Chicago (West Loop)",
  "Chicago",
  "Colorado Springs",
  "Denver",
  "Denver Downtown",
  "Indianapolis",
  "Minneapolis",
  "Minneapolis (City Center)",
  "Oklahoma",
  "Ottawa",
  "Spanish Fort",
  "Fresno",
  "Fort Worth",
  "Mississauga",
  "Rochester",
  "Washington",
  "Dallas",
  "Syracuse",
  "Long Beach",
  "Waterloo",
  "Winnipeg",
];

export const bigAxeAddonLocations = [
  "Alexandria",
  "Atlanta",
  "Burlington",
  "Charlotte",
  "Chicago (Lake View)",
  "Chicago (West Loop)",
  "Chicago",
  "Colorado Springs",
  "Dallas",
  "Denver",
  "Denver Downtown",
  "Fairfax",
  "Fort Worth",
  "Indianapolis",
  "Minneapolis",
  "Minneapolis (City Center)",
  "Oklahoma",
  "Ottawa",
  "San Francisco",
  "Spanish Fort",
  "Syracuse",
  "Vaughan",
  "Washington",
  "Waterloo",
  "Rochester",
  "Long Beach",
  "Surrey",
  "Winnipeg",
];

export const MarathonLeaguesLocations = [
  "Atlanta",
  "Alexandria",
  "Chicago",
  "Chicago (West Loop)",
  "Colorado Springs",
  "Denver Downtown",
  "Fort Worth",
  "Fresno",
  "Indianapolis",
  "Long Beach",
  "Minneapolis (City Center)",
  "Oklahoma City",
  "Oklahoma",
  "Ottawa",
  "Rochester",
  "San Francisco",
  "Spanish Fort",
  "Surrey",
  "Syracuse",
  "Waterloo",
  "Winnipeg",
];

export const RecLeaguesLocations = [
  // Canada
  "Burlington",
  "Ottawa",
  "Surrey",
  "Waterloo",
  "Winnipeg",
  "Mississauga",
  "Atlanta",
  "Alexandria",
  "Charlotte",
  "Chicago (West Loop)",
  "Colorado Springs",
  "Dallas",
  "Denver",
  "Fresno",
  "Indianapolis",
  "Long Beach",
  "Minneapolis",
  "Washington DC",
  "Oklahoma",
  "Rochester",
  "San Francisco",
  "Syracuse",
  "Fresno",
];

export const PromocodeLocations = [
  // 'Croydon',
  // 'Wembley, London',
  // 'Atlanta'
];

export const SocialLanesGroups = ["1", "2", "3", "4", "5", "+"];

export const SocialTimeslots = [
  "08:00",
  "08:45",
  "10:00",
  "10:45",
  "12:00",
  "12:45",
  "14:00",
  "14:45",
  "16:00",
  "16:45",
  "18:00",
  "18:45",
  "20:00",
  "20:45",
  "22:00",
];

export const SocialTimeslotsUk = [
  "11:30",
  "12:15",
  "13:30",
  "14:15",
  "15:30",
  "16:15",
  "17:30",
  "18:15",
  "19:30",
  "20:15",
  "21:30",
  "22:15",
];

export const MinSocialLaneSlot = "08:00";
export const MaxSocialLaneSlot = "22:00";

export const MinSocialLaneSlotUk = "11:30";
export const MaxSocialLaneSlotUk = "22:15";

export const closedLocations = [
  "washington",
  "denver",
  "croydon",
  "wembley, london",
];

export const closedLocationsForOffer = ["windsor", "waldorf", "nashville"];

export const getLocationLanes = (location: string) => {
  const foundLocation = locationLanes.find(loc => loc.location.toLowerCase() === location.toLowerCase());
  return foundLocation ? foundLocation.lanes : 0;
};

export const getDatesBetween = (startDate: Date, endDate: Date) => {
  const dateArray = [];
  const currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    dateArray.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dateArray;
};
